import {NgModule} from '@angular/core';
import {BlockUIModule} from 'primeng/blockui';
import {ProgressSpinnerModule} from 'primeng/progressspinner';
import {LgConfigPagePage} from './page/lg-config-page/lg-config-page.page';
import {LgLogicObjectComponent} from './component/object-components/logic-object-component/lg-logic-object.component';
import {LgLogicPagePage} from './page/lg-logic-page/lg-logic-page.page';
import {TeModule} from '../../feature-core/te/te.module';
import {DragDropModule} from 'primeng/dragdrop';
import {
    LgCalculationLogicTypeObjectComponent
} from './component/object-components/calculation-logic-type-object-component/lg-calculation-logic-type-object.component';
import {
    LgCalculationTestCaseComponent
} from './component/object-components/calculation-logic-type-object-component/shared/lg-calculation-test-case/lg-calculation-test-case.component';
import {LgCalculationLogicPagePage} from './page/lg-calculation-logic-page/lg-calculation-logic-page.page';
import {
    LgCalculationLogicTypeStepComponent
} from './component/object-components/calculation-logic-type-object-component/shared/calculation-logic-type-step-component/lg-calculation-logic-type-step.component';
import {
    LgLogicObjectFullComponent
} from './component/object-components/logic-object-component/view/lg-logic-object-component-full/lg-logic-object-full.component';
import {
    LgLogicObjectSideComponent
} from './component/object-components/logic-object-component/view/lg-logic-object-component-side/lg-logic-object-side.component';
import {
    LgLogicObjectBaseComponent
} from './component/object-components/logic-object-component/view/lg-logic-object-base.component';
import {TmModule} from '../../feature-core/tm/tm.module';
import {
    LgCalculationLogicTypeObjectBaseComponent
} from './component/object-components/calculation-logic-type-object-component/view/lg-calculation-logic-type-object-base.component';
import {
    LgCalculationLogicTypeObjectSideComponent
} from './component/object-components/calculation-logic-type-object-component/view/lg-calculation-logic-type-object-side/lg-calculation-logic-type-object-side.component';
import {
    LgCalculationLogicTypeObjectFullComponent
} from './component/object-components/calculation-logic-type-object-component/view/lg-calculation-logic-type-object-full/lg-calculation-logic-type-object-full.component';
import {LG_ENTITY_PROVIDER} from './lg.entity-provider';
import {UiModule} from '../../core/ui/ui.module';
import {DynamicModule} from '../../core/shared/interface/dynamic-module.interface';
import {ModuleRegistryService} from '../../core/shared/interface/module-registration.service';
import {CoreModule} from '../../core/core.module';
import {PMessagesComponent} from '../../core/shared/p-messages/p-messages.component';
import {LG_TEST_PROVIDERS} from './test/lg-test-definition';
import {CodeEditorComponent} from './component/protected-components/code-editor/code-editor.component';
import {LgVariablesComponent} from './component/protected-components/lg-variables/lg-variables.component';
import {LgTestCaseComponent} from './component/protected-components/lg-test-case/lg-test-case.component';
import {LgLogicPageComponent} from './component/protected-components/logic-page-component/lg-logic-page.component';
import {LgWorkbenchPagePage} from './page/lg-workbench-page/lg-workbench-page.page';
import {LgFlowObjectPagePage} from './page/lg-flow-object-page/lg-flow-object-page.page';
import {LgFlowDesignerComponent} from './component/protected-components/lg-flow-designer/lg-flow-designer.component';
import {LgExecutionMonitorComponent} from './component/protected-components/lg-execution-monitor/lg-execution-monitor.component';
import {LgTestRunnerComponent} from './component/protected-components/lg-test-runner/lg-test-runner.component';
import {LgLogicFlowStepObjectComponent} from './component/object-components/logic-flow-step-object-component/lg-logic-flow-step-object.component';
import {LgLogicFlowObjectComponent} from './component/object-components/logic-flow-object-component/lg-logic-flow-object.component';
import {LgLogicFlowObjectBaseComponent} from './component/object-components/logic-flow-object-component/view/lg-logic-flow-object-base.component';
import {LgLogicFlowObjectFullComponent} from './component/object-components/logic-flow-object-component/view/lg-logic-flow-object-full/lg-logic-flow-object-full.component';
import {LgLogicFlowObjectSideComponent} from './component/object-components/logic-flow-object-component/view/lg-logic-flow-object-side/lg-logic-flow-object-side.component';
import {LgPocCalculationMappingAssistantPagePage} from './page/lg-poc-calculation-mapping-assistant-page/lg-poc-calculation-mapping-assistant-page.page';
import {LgPocWizardStepBasicsComponent} from './page/lg-poc-calculation-mapping-assistant-page/components/wizard-step-basics/lg-poc-wizard-step-basics.component';
import {LgPocWizardStepMappingComponent} from './page/lg-poc-calculation-mapping-assistant-page/components/wizard-step-mapping/lg-poc-wizard-step-mapping.component';
import {LgPocWizardStepDoneComponent} from './page/lg-poc-calculation-mapping-assistant-page/components/wizard-step-done/lg-poc-wizard-step-done.component';
import {LgLogicFlowExecutionObjectComponent} from './component/object-components/logic-flow-execution-object-component/lg-logic-flow-execution-object.component';
import {LgLogicFlowTestCaseObjectComponent} from './component/object-components/logic-flow-test-case-object-component/lg-logic-flow-test-case-object.component';
import {LgPocExecutionVisualizerPagePage} from './page/lg-poc-execution-visualizer-page/lg-poc-execution-visualizer-page.page';
import {LgPocPipelineVisualizerComponent} from './page/lg-poc-execution-visualizer-page/components/pipeline-visualizer/lg-poc-pipeline-visualizer.component';
import {LgPocFlowExecutionVisualizerPagePage} from './page/lg-poc-flow-execution-visualizer-page/lg-poc-flow-execution-visualizer-page.page';
import {LgFlowTestRunnerComponent} from './component/protected-components/lg-flow-test-runner/lg-flow-test-runner.component';
import {LgTestCaseSetupComponent} from './component/protected-components/lg-test-case-setup/lg-test-case-setup.component';
import {LgFlowExecutionTreePanelComponent} from './component/protected-components/lg-flow-execution-tree-panel/lg-flow-execution-tree-panel.component';
import {LgFlowValueRendererComponent} from './component/protected-components/lg-flow-value-renderer/lg-flow-value-renderer.component';
import {LgFlowVariableStorePanelComponent} from './component/protected-components/lg-flow-variable-store-panel/lg-flow-variable-store-panel.component';
import {LgFlowTraceSummaryComponent} from './component/protected-components/lg-flow-trace-summary/lg-flow-trace-summary.component';
import {LgFlowTraceDetailPage} from './page/lg-flow-trace-detail/lg-flow-trace-detail.page';
import {LgFlowTraceDetailPanelComponent} from './component/protected-components/lg-flow-trace-detail-panel/lg-flow-trace-detail-panel.component';
import {LgFlowDeclarationRailComponent} from './component/protected-components/lg-flow-declaration-rail/lg-flow-declaration-rail.component';
// TM-1000001563: reusable step-detail sidebar (extracted from lg-flow-test-runner).
import {LgFlowStepDetailSidebarComponent} from './component/protected-components/lg-flow-step-detail-sidebar/lg-flow-step-detail-sidebar.component';
// TM-1000001563: reusable flow-I/O detail panel (extracted from lg-flow-test-runner).
import {LgFlowIoDetailPanelComponent} from './component/protected-components/lg-flow-io-detail-panel/lg-flow-io-detail-panel.component';
// TM-1000001563: removed paste-JSON LogicFlow import dialog — replaced by a native file picker on lg-config-page.
// TM-1000001726: structured Format-Function editor for LogicLanguage.format.
import {FormatScriptEditorComponent} from './component/protected-components/format-script-editor/format-script-editor.component';
// TM-1000001726 Phase 2: structured Module-Function editor for LogicLanguage.module_function.
import {ModuleFunctionScriptEditorComponent} from './component/protected-components/module-function-script-editor/module-function-script-editor.component';
// TM-1000001726 Phase 3: structured CRUD-Script editor for LogicLanguage.crud.
import {CrudScriptEditorComponent} from './component/protected-components/crud-script-editor/crud-script-editor.component';
// TM-1000001726: Compilation-Cache-Monitor — Cross-Tenant + per-Tenant Stats für Groovy/SpEL-Cache.
import {LgCompilationCacheMonitorPage} from './page/lg-compilation-cache-monitor-page/lg-compilation-cache-monitor-page.page';
// TM-1000001726: Cache-Memory-Panel — Live JVM-Memory-Anzeige (Metaspace, Heap, Code-Cache, Compilation-Cache).
import {CacheMemoryPanelComponent} from './component/protected-components/cache-memory-panel/cache-memory-panel.component';
// lg.LogicMappingTable object component (dispatcher + base + full + side) and its object page.
// The entity has two child collections, so the Complex Configuration Entity Rule requires an object
// page instead of flat tabs on the config page.
import {
    LgLogicMappingTableObjectComponent
} from './component/object-components/logic-mapping-table-object-component/lg-logic-mapping-table-object.component';
import {
    LgLogicMappingTableObjectBaseComponent
} from './component/object-components/logic-mapping-table-object-component/view/lg-logic-mapping-table-object-base.component';
import {
    LgLogicMappingTableObjectFullComponent
} from './component/object-components/logic-mapping-table-object-component/view/lg-logic-mapping-table-object-full/lg-logic-mapping-table-object-full.component';
import {
    LgLogicMappingTableObjectSideComponent
} from './component/object-components/logic-mapping-table-object-component/view/lg-logic-mapping-table-object-side/lg-logic-mapping-table-object-side.component';
import {
    LgMappingTableObjectPagePage
} from './page/lg-mapping-table-object-page/lg-mapping-table-object-page.page';

// Mapping-language panels (owned by the component specialist, declared here because lg.module.ts has a
// single owner). Selectors bound from the two object components:
//   <mvs-lg-mapping-quick-test>   — mapping-table object component, section 'quickTest'
//   <mvs-lg-mapping-table-select> — logic object component, language 'mapping'
//   <mvs-lg-logic-quick-test>     — logic object component, section 'quickTest'
//   <mvs-lg-logic-mappings>       — logic object component, section 'mappings'
import {
    LgMappingQuickTestComponent
} from './component/protected-components/lg-mapping-quick-test/lg-mapping-quick-test.component';
import {
    LgMappingTableSelectComponent
} from './component/protected-components/lg-mapping-table-select/lg-mapping-table-select.component';
import {
    LgLogicQuickTestComponent
} from './component/protected-components/lg-logic-quick-test/lg-logic-quick-test.component';
import {
    LgLogicMappingsComponent
} from './component/protected-components/lg-logic-mappings/lg-logic-mappings.component';

import {ContextMenu} from 'primeng/contextmenu';
import {MenuModule} from 'primeng/menu';
import {IconFieldModule} from 'primeng/iconfield';
import {InputIconModule} from 'primeng/inputicon';

@NgModule({
    declarations: [
        LgConfigPagePage,
        LgLogicObjectComponent,
        LgLogicPagePage,
        LgVariablesComponent,
        CodeEditorComponent,
        LgTestCaseComponent,
        LgCalculationLogicTypeObjectComponent,
        LgCalculationTestCaseComponent,
        LgCalculationLogicPagePage,
        LgLogicPageComponent,
        LgCalculationLogicTypeStepComponent,
        LgLogicObjectFullComponent,
        LgLogicObjectSideComponent,
        LgLogicObjectBaseComponent,
        LgCalculationLogicTypeObjectBaseComponent,
        LgCalculationLogicTypeObjectSideComponent,
        LgCalculationLogicTypeObjectFullComponent,
        LgWorkbenchPagePage,
        LgFlowObjectPagePage,
        LgFlowDesignerComponent,
        LgExecutionMonitorComponent,
        LgTestRunnerComponent,
        LgLogicFlowStepObjectComponent,
        LgLogicFlowObjectComponent,
        LgLogicFlowObjectBaseComponent,
        LgLogicFlowObjectFullComponent,
        LgLogicFlowObjectSideComponent,
        LgPocCalculationMappingAssistantPagePage,
        LgPocWizardStepBasicsComponent,
        LgPocWizardStepMappingComponent,
        LgPocWizardStepDoneComponent,
        LgLogicFlowExecutionObjectComponent,
        LgLogicFlowTestCaseObjectComponent,
        LgPocExecutionVisualizerPagePage,
        LgPocPipelineVisualizerComponent,
        LgPocFlowExecutionVisualizerPagePage,
        LgFlowTestRunnerComponent,
        LgTestCaseSetupComponent,
        LgFlowExecutionTreePanelComponent,
        LgFlowValueRendererComponent,
        LgFlowVariableStorePanelComponent,
        LgFlowTraceSummaryComponent,
        LgFlowTraceDetailPage,
        LgFlowTraceDetailPanelComponent,
        LgFlowDeclarationRailComponent,
        // TM-1000001563: register the extracted reusable sidebar + flow-I/O panel.
        LgFlowStepDetailSidebarComponent,
        LgFlowIoDetailPanelComponent,
        // TM-1000001563: paste-JSON LogicFlow import dialog removed — superseded by the native file picker on lg-config-page.
        // TM-1000001726: Format-Function structured editor.
        FormatScriptEditorComponent,
        // TM-1000001726 Phase 2: Module-Function structured editor.
        ModuleFunctionScriptEditorComponent,
        // TM-1000001726 Phase 3: CRUD-Script structured editor.
        CrudScriptEditorComponent,
        // TM-1000001726: Compilation-Cache-Monitor page.
        LgCompilationCacheMonitorPage,
        // TM-1000001726: Cache-Memory-Panel.
        CacheMemoryPanelComponent,
        // lg.LogicMappingTable object component + object page.
        LgLogicMappingTableObjectComponent,
        LgLogicMappingTableObjectBaseComponent,
        LgLogicMappingTableObjectFullComponent,
        LgLogicMappingTableObjectSideComponent,
        LgMappingTableObjectPagePage,
        // Mapping-language panels.
        LgMappingQuickTestComponent,
        LgMappingTableSelectComponent,
        LgLogicQuickTestComponent,
        LgLogicMappingsComponent,
    ],
    exports: [
        LgConfigPagePage,
        LgLogicObjectComponent,
        LgLogicPagePage,
        LgVariablesComponent,
        CodeEditorComponent,
        LgTestCaseComponent,
        LgCalculationLogicTypeObjectComponent,
        LgCalculationTestCaseComponent,
        LgCalculationLogicPagePage,
        LgLogicPageComponent,
        LgCalculationLogicTypeStepComponent,
        LgLogicObjectFullComponent,
        LgLogicObjectSideComponent,
        LgLogicObjectBaseComponent,
        LgCalculationLogicTypeObjectBaseComponent,
        LgCalculationLogicTypeObjectSideComponent,
        LgCalculationLogicTypeObjectFullComponent,
        LgWorkbenchPagePage,
        LgFlowObjectPagePage,
        LgFlowDesignerComponent,
        LgExecutionMonitorComponent,
        LgTestRunnerComponent,
        LgLogicFlowStepObjectComponent,
        LgLogicFlowObjectComponent,
        LgLogicFlowObjectBaseComponent,
        LgLogicFlowObjectFullComponent,
        LgLogicFlowObjectSideComponent,
        LgPocCalculationMappingAssistantPagePage,
        LgPocWizardStepBasicsComponent,
        LgPocWizardStepMappingComponent,
        LgPocWizardStepDoneComponent,
        LgLogicFlowExecutionObjectComponent,
        LgLogicFlowTestCaseObjectComponent,
        LgPocExecutionVisualizerPagePage,
        LgPocPipelineVisualizerComponent,
        LgPocFlowExecutionVisualizerPagePage,
        LgFlowTestRunnerComponent,
        LgTestCaseSetupComponent,
        LgFlowExecutionTreePanelComponent,
        LgFlowValueRendererComponent,
        LgFlowVariableStorePanelComponent,
        LgFlowTraceSummaryComponent,
        LgFlowTraceDetailPage,
        LgFlowTraceDetailPanelComponent,
        LgFlowDeclarationRailComponent,
        // TM-1000001563: export the extracted reusable sidebar + flow-I/O panel.
        LgFlowStepDetailSidebarComponent,
        LgFlowIoDetailPanelComponent,
        // TM-1000001563: paste-JSON LogicFlow import dialog removed — superseded by the native file picker on lg-config-page.
        // TM-1000001726: Format-Function structured editor.
        FormatScriptEditorComponent,
        // TM-1000001726 Phase 2: Module-Function structured editor.
        ModuleFunctionScriptEditorComponent,
        // TM-1000001726 Phase 3: CRUD-Script structured editor.
        CrudScriptEditorComponent,
        // TM-1000001726: Compilation-Cache-Monitor page.
        LgCompilationCacheMonitorPage,
        // TM-1000001726: Cache-Memory-Panel.
        CacheMemoryPanelComponent,
        // lg.LogicMappingTable object component + object page.
        LgLogicMappingTableObjectComponent,
        LgLogicMappingTableObjectBaseComponent,
        LgLogicMappingTableObjectFullComponent,
        LgLogicMappingTableObjectSideComponent,
        LgMappingTableObjectPagePage,
        // Mapping-language panels.
        LgMappingQuickTestComponent,
        LgMappingTableSelectComponent,
        LgLogicQuickTestComponent,
        LgLogicMappingsComponent,
    ],
    imports: [
        CoreModule,
        UiModule,
        BlockUIModule,
        ProgressSpinnerModule,
        TeModule,
        DragDropModule,
        TmModule,
        PMessagesComponent,
        ContextMenu,
        MenuModule,
        IconFieldModule,
        InputIconModule,
    ],
    providers: [LG_ENTITY_PROVIDER, LG_TEST_PROVIDERS]
})
export class LgModule implements DynamicModule {

    alias = 'lg';

    constructor(private moduleRegistry: ModuleRegistryService) {
        this.moduleRegistry.registerModule(this);
    }

    getKpiComponent() {
        return null;
    }

    getStatisticsComponent() {
        return null;
    }
}
